module.exports = __webpack_public_path__ + "static/media/3@3x.d8c55956.png";